import { render, staticRenderFns } from "./edificio-details.vue?vue&type=template&id=c1d9fb4e"
import script from "./edificio-details.vue?vue&type=script&lang=js"
export * from "./edificio-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports